var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUserPen = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.897,
    height: 16,
    viewBox: "0 0 19.897 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "user-pen",
    d: "M7,7A3,3,0,1,0,4,4,3,3,0,0,0,7,7ZM1,15h9.067l-.031.119a1.509,1.509,0,0,0,.044.881H.928A.928.928,0,0,1,0,15.069,5.57,5.57,0,0,1,5.571,9.5H8.427a5.557,5.557,0,0,1,3.618,1.334l-.709.709A4.548,4.548,0,0,0,8.427,10.5H5.571A4.574,4.574,0,0,0,1,15ZM3,4A4,4,0,1,1,7,8,4,4,0,0,1,3,4Zm15.21,4.249a.5.5,0,0,0-.706,0l-.775.775,1.25,1.25.775-.775a.5.5,0,0,0,0-.706Zm-5.508,4.8a.492.492,0,0,0-.131.231l-.384,1.531,1.531-.384a.5.5,0,0,0,.231-.131l3.321-3.318-1.25-1.25Zm4.093-5.508a1.5,1.5,0,0,1,2.121,0l.544.544a1.5,1.5,0,0,1,0,2.121l-4.8,4.8a1.5,1.5,0,0,1-.7.394l-2.34.584a.5.5,0,0,1-.606-.606l.584-2.34a1.524,1.524,0,0,1,.394-.7Z",
    fill: "#1a1a1a"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUserPen);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/user-pen.b8f357326161959c2a81127e37cd3d3a.svg";